import type { ProgressPayload } from '@diagon-alley/common';
import { Card, Group, Progress, Stack, Text } from '@mantine/core';
import { CircleNotch } from '@phosphor-icons/react';

import styles from './ReportsContainer.module.css';

interface ProgressCardProps {
    payload: ProgressPayload;
}

/**
 * Inline progress card for multi-step operations. The percentage is
 * computed from step / total. Re-emit at later steps with the same
 * toolCallId to update in place (handled in useReportingThread when
 * the orchestrator wires same-id grouping in slice 5).
 */
export default function ProgressCard({ payload }: ProgressCardProps) {
    const pct = Math.min(
        100,
        Math.round((payload.step / payload.total) * 100),
    );
    return (
        <Card withBorder radius="md" className={styles.progressCard}>
            <Stack gap={6}>
                <Group gap="xs" align="center">
                    <CircleNotch size={14} className={styles.progressSpinner} />
                    <Text size="xs" fw={500}>
                        {payload.label}
                    </Text>
                    <Text size="xs" c="dimmed">
                        ({payload.step}/{payload.total})
                    </Text>
                </Group>
                <Progress value={pct} size="xs" />
            </Stack>
        </Card>
    );
}
